import React, { Component } from "react"

import { Menu, MenuItem } from "../styled-components"

class PageMenu extends Component {
  render() {
    return (
      <Menu>
        <MenuItem to="/events">Events</MenuItem>
        <MenuItem to="/tagungen">Tagungen</MenuItem>
        <MenuItem to="/incentives">Incentives</MenuItem>
        <MenuItem to="/messen">Messen</MenuItem>
        <MenuItem to="/konzerte">Konzerte</MenuItem>
        <MenuItem to="/architektur">Architektur</MenuItem>
        <MenuItem to="/impressionen">Impressionen</MenuItem>
        <MenuItem to="/koeln">Köln</MenuItem>
        <MenuItem to="/uber">Über mich</MenuItem>
      </Menu>
    )
  }
}

export default PageMenu



// WEBPACK FOOTER //
// ./src/partials/PageMenu.js